import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import { createPledge, resetPledge } from 'actions/pledge';
import { fetchLabelsIfNeeded } from 'actions/labels';
import { fetchFactsIfNeeded } from 'actions/facts';

import { CreatePledge } from 'views';

const mapStateToProps = state => ({
  facts: state.facts,
  labels: state.labels,
  pledge: state.pledge
});

const mapDispatchToProps = dispatch => ({
  actions: {
    ...bindActionCreators(
      {
        createPledge: createPledge,
        push
      },
      dispatch
    ),
    onMount: () => {
      dispatch(fetchLabelsIfNeeded({ fields: ['id', 'name'] }));
      dispatch(fetchFactsIfNeeded());
    },
    onUnmount: () => {
      dispatch(resetPledge());
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePledge);
